<template>
	<el-dialog
		title="Select User"
		:visible.sync="dialogVisible"
		width="800px"
		append-to-body
		@close="handleDialogClose"
	>
		<div class="user_dialog">
			<el-input
				v-model="searchKeyword"
				placeholder="Search by name"
				clearable
				class="search_input"
			>
				<i slot="prefix" class="el-input__icon el-icon-search"></i>
			</el-input>

			<el-table
				:data="pagedUserList"
				height="300"
				border
				highlight-current-row
			>
				<el-table-column
					prop="user_id"
					label="User ID"
					width="120"
				/>

				<el-table-column
					prop="username"
					label="User Name"
					width="140"
				/>

				<!-- <el-table-column
					prop="company"
					label="Company"
				>
					<template #default="scope">
						{{ scope.row.company_name || "/" }}
					</template>
				</el-table-column> -->

				<el-table-column
					prop="dept"
					label="Department"
				>
					<template #default="scope">
						{{ scope.row.departments_name || "/" }}
					</template>
				</el-table-column>

				<el-table-column
					label="Actions"
					width="120"
					align="center"
				>
					<template slot-scope="scope">
						<el-button
							size="mini"
							type="primary"
							@click="selectUser(scope.row)"
						>
							Select
						</el-button>
					</template>
				</el-table-column>
			</el-table>

			<div
				v-if="!filteredList.length"
				class="empty_text"
			>
				No matching users found.
			</div>

			<div
				class="pagination"
				v-if="filteredList.length"
			>
				<el-pagination
					background
					layout="total, sizes, prev, pager, next"
					:total="filteredList.length"
					:page-size="pageSize"
					:page-sizes="[5, 10, 20, 50]"
					:current-page.sync="currentPage"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				/>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		name: "UserSelectDialog",
		props: {
			visible: Boolean,
			userList: {
				type: Array,
				default: () => [],
			},
			selectedId: [String, Number],
		},
		data() {
			return {
				dialogVisible: false,
				searchKeyword: "",
				tempSelectedId: null,
				pageSize: 5,
				currentPage: 1,
			};
		},

		computed: {
			filteredList() {
				const keyword = this.searchKeyword.trim().toLowerCase();
				if (!keyword) return this.userList;

				return this.userList.filter((item) => {
					const name = String(item.username || "")
						.trim()
						.toLowerCase();
					return name.includes(keyword);
				});
			},

			pagedUserList() {
				const start = (this.currentPage - 1) * this.pageSize;
				return this.filteredList.slice(start, start + this.pageSize);
			},
		},

		watch: {
			visible: {
				immediate: true,
				handler(val) {
					this.dialogVisible = val;
					if (val) {
						this.tempSelectedId = this.selectedId;
						this.currentPage = 1;
					}
				},
			},

			dialogVisible(val) {
				this.$emit("update:visible", val);
			},

			selectedId(val) {
				if (this.dialogVisible) {
					this.tempSelectedId = val;
				}
			},

			searchKeyword() {
				this.currentPage = 1;
			},
		},

		methods: {
			selectUser(row) {
				this.tempSelectedId = row.id;
				this.$emit("confirm", {
					id: row.id,
					user: row,
				});
				this.dialogVisible = false;
			},
			handleDialogClose() {
				this.searchKeyword = "";
				this.currentPage = 1;
			},
			handleSizeChange(size) {
				this.pageSize = size;
				this.currentPage = 1;
			},
			handleCurrentChange(page) {
				this.currentPage = page;
			},
		},
	};
</script>

<style lang="less" scoped>
	.user_dialog {
		.search_input {
			margin-bottom: 15px;
		}

		.selected_box {
			margin-bottom: 10px;
		}

		.pagination {
			margin-top: 10px;
			text-align: right;
		}

		.empty_text {
			text-align: center;
			color: #999;
			padding: 20px 0;
		}

		::v-deep .selected-row {
			background-color: #f0f7ff !important;
		}
	}
</style>